import { render, staticRenderFns } from "./SupplierPurchaseSummary.vue?vue&type=template&id=60f7df94&scoped=true"
import script from "./SupplierPurchaseSummary.vue?vue&type=script&lang=js"
export * from "./SupplierPurchaseSummary.vue?vue&type=script&lang=js"
import style0 from "./SupplierPurchaseSummary.vue?vue&type=style&index=0&id=60f7df94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f7df94",
  null
  
)

export default component.exports